class CommentsCollection extends Backbone.Collection

  comparator: (m) ->
    -new Date(m.get("timestamp")).getTime()

  initialize: ->
    # console.log 'initCommentsCollection'

  like: (slideId, id) ->
    comment = @get(id)

    likes = comment.get("likes") or 0
    isLikedByLearner = comment.get("isLikedByLearner")

    if isLikedByLearner
      isLikedByLearner = false
      likes -= 1
    else
      likes += 1
      isLikedByLearner = true

    comment.set { likes, isLikedByLearner }
    return isLikedByLearner

  flag: (id) ->
    comment = @get(id)

    isFlaggedByLearner = comment.get("isFlaggedByLearner")

    if not isFlaggedByLearner
      isFlaggedByLearner = true
    else
      return false

    comment.set { isFlaggedByLearner }
    return true

  delete: (id) ->
    comment = @get(id)
    @remove comment


module.exports = CommentsCollection
